export default __webpack_public_path__ + "static/media/Connect Wallet.da9f26f1.gif";